// extracted by mini-css-extract-plugin
module.exports = {"dialog--footer":"dialog--footer__kGZ-u","dialog--footer__padding-off":"dialog--footer__padding-off__acaSE"};